module.exports = __webpack_public_path__ + "static/assets/d60d840b205d6d83d8bae2cf2622e9cb.svg";